import script from "./LaputaMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./LaputaMedia.vue?vue&type=script&setup=true&lang=js"

import "./LaputaMedia.vue?vue&type=style&index=0&id=2f99dcaf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f99dcaf"]])

export default __exports__